import { File } from './file'
import { Translator } from './translator'

export class Page extends Translator {
    titleEn:string
    titleKh: string
    descriptionEn: string
    descriptionKh: string
    image:File
    get title():string{
        return this.translate(this.titleEn,this.titleKh)
    }
    get description():string{
        return this.translate(this.descriptionEn,this.descriptionKh)
    }
}